// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_exn from "rescript/lib/es6/js_exn.js";
import * as Core__JSON from "@rescript/core/src/Core__JSON.bs.js";
import * as Core__List from "@rescript/core/src/Core__List.bs.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";

function make(input) {
  if (typeof input !== "object") {
    return /* [] */0;
  }
  var keys = input._0;
  if (keys.length !== 0) {
    return Core__List.fromArray(keys);
  }
  
}

function makeExn(input) {
  if (typeof input !== "object") {
    return /* [] */0;
  }
  var keys = input._0;
  if (keys.length !== 0) {
    return Core__List.fromArray(keys);
  } else {
    return /* [] */0;
  }
}

function append(path, indexer) {
  return Core__List.concat(path, {
              hd: indexer,
              tl: /* [] */0
            });
}

function safeMake(input, _schema) {
  if (typeof input !== "object") {
    return /* [] */0;
  }
  var keys = input._0;
  if (keys.length !== 0) {
    return Core__List.fromArray(keys);
  }
  
}

function toDisplayString(path) {
  return Core__List.toArray(Core__List.map(path, (function (x) {
                      if (x.TAG === "Field") {
                        return x._0;
                      } else {
                        return x._0.toString();
                      }
                    }))).join("::");
}

function toFieldsOnlyString(path) {
  return Core__List.toArray(Core__List.filterMap(path, (function (x) {
                      if (x.TAG === "Field") {
                        return x._0;
                      }
                      
                    }))).join("::");
}

function serialize(path) {
  return Core__List.toArray(Core__List.map(path, (function (x) {
                    return x._0;
                  })));
}

function deserialize(json) {
  return Core__Option.flatMap(Core__JSON.Decode.array(json), (function (arr) {
                var arrayElementsOk = arr.every(function (el) {
                      var match = Core__JSON.Classify.classify(el);
                      if (typeof match !== "object") {
                        return false;
                      }
                      switch (match.TAG) {
                        case "String" :
                        case "Number" :
                            return true;
                        default:
                          return false;
                      }
                    });
                if (!arrayElementsOk) {
                  return ;
                }
                var path = arr.map(function (el) {
                      var str = Core__JSON.Classify.classify(el);
                      if (typeof str === "object") {
                        switch (str.TAG) {
                          case "String" :
                              return {
                                      TAG: "Field",
                                      _0: str._0
                                    };
                          case "Number" :
                              return {
                                      TAG: "At",
                                      _0: Math.floor(str._0) | 0
                                    };
                          default:
                            
                        }
                      }
                      return Js_exn.raiseError("Unexpected Path element after validating it was a valid Path. Path: " + arr.map(function (prim) {
                                        return JSON.stringify(prim);
                                      }).join(","));
                    });
                if (path.length !== 0) {
                  return make({
                              TAG: "Nested",
                              _0: path
                            });
                } else {
                  return /* [] */0;
                }
              }));
}

function extractValue(_path, getValue, _root) {
  while(true) {
    var root = _root;
    var path = _path;
    if (!path) {
      return Caml_option.some(root);
    }
    var root$1 = getValue(root, path.hd);
    if (root$1 === undefined) {
      return ;
    }
    _root = Caml_option.valFromOption(root$1);
    _path = path.tl;
    continue ;
  };
}

function setValueJSON(path, value, root) {
  if (!path) {
    return value;
  }
  var tail = path.tl;
  var head = path.hd;
  if (head.TAG === "Field") {
    var key = head._0;
    var dict = Core__Option.getOr(Core__JSON.Decode.object(root), {});
    if (tail) {
      var emptyValue;
      emptyValue = tail.hd.TAG === "Field" ? ({}) : [];
      var nested = Core__Option.getOr(dict[key], emptyValue);
      dict[key] = setValueJSON(tail, value, nested);
    } else {
      dict[key] = value;
    }
    return dict;
  }
  var position = head._0;
  var array = Core__Option.getOr(Core__JSON.Decode.array(root), []);
  if (tail) {
    var emptyValue$1;
    emptyValue$1 = tail.hd.TAG === "Field" ? ({}) : [];
    var nested$1 = Core__Option.getOr(array[position], emptyValue$1);
    array[position] = setValueJSON(tail, value, nested$1);
  } else {
    array[position] = value;
  }
  return array;
}

var Path = {
  make: make,
  makeExn: makeExn,
  append: append,
  safeMake: safeMake,
  toDisplayString: toDisplayString,
  toFieldsOnlyString: toFieldsOnlyString,
  serialize: serialize,
  deserialize: deserialize
};

export {
  Path ,
  extractValue ,
  setValueJSON ,
}
/* No side effect */
